import palette from './palette'
import colors from '../colors'

const bodyBackgroundColor = colors['color-page-background--solid']
const mainBackgroundColor = colors['color-background-primary']
const dimTextColor = palette.gray7
const mainTextColor = colors.text
const dangerColor = colors['action-destructive']
const successColor = colors['feedback--success']
const secondaryMain = colors['action-secondary']
const fieldColor = palette.gray9
const dimWhite = colors['text--deemphasis']
const borderColor = colors.border
const darkBackground = colors['color-background-primary--dim']
const cautionMain = colors['risk--medium']
const ribbonColor = palette.ribbonColor
const mainLinkColor = colors['action-primary']
const borderMain = colors.border
const linkHoverColor = palette.blue4

export const theme = {
  name: 'dark',

  fontSizes: ['12px', '14px', '16px', '20px', '24px', '32px', '48px', '64px', '72px'],
  space: ['0', '4px', '8px', '16px', '32px', '64px', '128px', '256px', '512px'],
  breakpoints: ['40em', '56em', '64em'],

  fonts: {
    body: 'var(--maui-typography-html-font-family)'
  },

  fontWeights: {
    light: 300,
    body: 400,
    bold: 600,
  },

  colors,
  palette,

  mainBackgroundColor,
  mainTextColor,
  mainLinkColor,
  dimTextColor,
  dangerColor,
  successColor,
  secondaryMain,
  bodyBackgroundColor,
  dimWhite,
  fieldColor,
  darkBackground,
  cautionMain,
  ribbonColor,
  borderMain,

  amcharts: {
    colorList: [
      '#C74A37',
      '#5F986A',
      '#965AA9',
      '#4A9BBC',
      '#DE8E47',
      '#C24976',
      '#F0DF6D',
      '#73C4AC',
      '#939FB2',
      '#CC00FF',
    ],
    pieSeriesStroke: mainBackgroundColor,
    mapFill: '#dddddd',
    MapPolygonSeries: {
      fill: '#dddddd',
      stroke: '#999999',
    },
    heatPalettes: {
      danger: {
        stroke: '#dd0000',
        min: '#fff5f0',
        max: '#67000d',
      },
      source: {
        stroke: '#40004B',
        min: palette.purple4,
        max: palette.purple1,
      }
    },
    legend: {
      border: `1px solid ${mainTextColor}`,
      backgroundColor: palette.dimBackground,
    },
    confidenceColors: {
      low: '#FEE5D9',
      medium: '#EF3B2C',
      high: '#67000D',
    }
  },

  articlesWidget: {
    item: {
      backgroundColor: mainBackgroundColor,
      borderColor,
      color: mainTextColor,
    },
    itemDate: {
      color: dimTextColor,
    }
  },

  avatar: {
    backgroundColor: colors['color-background-secondary'],
    color: colors.text,
    ':hover': {
      backgroundColor: linkHoverColor,
    },
  },

  body: {
    backgroundColor: bodyBackgroundColor,
    color: mainTextColor,
  },

  checkbox: {
    default: {
      color: mainTextColor,
      active: palette.blue2
    }
  },

  button: {
    primary: {
      backgroundColor: colors['action-primary'],
      color: colors['text--reverse'],
      fontWeight: '700',
      ':hover': {
        color: colors['text--reverse'],
        backgroundColor: colors['action-primary--deemphasis'],
      },
      ':active': {
        color: colors['text--reverse'],
        backgroundColor: colors['action-primary--emphasis'],
      },
      ':disabled': {
        color: colors['text--reverse'],
        backgroundColor: colors['action-secondary'],
        cursor: 'default',
      },
    },

    'primary-transparent': {
      color: colors['action-primary'],
      fontWeight: '700',
      ':hover': {
        textDecoration: 'underline',
        color: colors['action-primary--deemphasis'],
      },
      ':active': {
        color: colors['action-primary--emphasis'],
      },
      ':disabled': {
        color: colors['text--deemphasis'],
      }
    },

    secondary: {
      color: colors.text,
      fontWeight: '700',
      borderColor: colors.text,
      ':hover': {
        color: colors['text--deemphasis'],
        borderColor: colors['text--deemphasis'],
      },
      ':active': {
        color: colors['text--emphasis'],
        borderColor: colors['text--emphasis'],
      },
      ':disabled': {
        color: colors['text--deemphasis'],
      }
    },

    'secondary-transparent': {
      color: colors.text,
      fontWeight: '700',
      ':hover': {
        color: colors['text--deemphasis'],
        textDecoration: 'underline',
      },
      ':active': {
        color: colors['text--emphasis'],
      },
      ':disabled': {
        color: colors['text--deemphasis'],
      }
    },

    danger: {
      backgroundColor: colors['action-destructive'],
      color: colors['text--reverse'],
      fontWeight: '700',
      ':hover': {
        backgroundColor: colors['action-destructive--deemphasis'],
      },
      ':active': {
        backgroundColor: colors['action-destructive--emphasis'],
      },
    },

    'danger-transparent': {
      fontWeight: '700',
      color: colors['action-destructive'],
      ':hover': {
        color: colors['action-destructive--deemphasis'],
        textDecoration: 'underline',
      },
      ':active': {
        color: colors['action-destructive--emphasis'],
      },
    },

    outline: {
      color: colors['action-secondary'],
      borderColor: colors['action-secondary'],
      backgroundColor: colors.transparent,
      ':hover': {
        color: colors['action-primary'],
        borderColor: colors['action-primary'],
        backgroundColor: colors.transparent,
      },
      ':disabled': {
        color: colors['text--deemphasis'],
      }
    },

    plain: {
    },

    unstyled: {
      color: 'inherit',
      background: 'none',
      margin: 0,
      padding: 0,
      border: 0,
      ':disabled': {
        cursor: 'not-allowed',
      },
    },

    'unstyled-block': {
      display: 'block',
      textAlign: 'left',
      width: '100%',
      color: 'inherit',
      background: 'none',
      margin: 0,
      padding: 0,
      border: 0,
      ':disabled': {
        cursor: 'not-allowed',
      },
    }
  },

  cve: {
    default: {
      color: colors.text
    },
    low: {
      color: colors['risk--low']
    },
    medium: {
      color: colors['risk--medium']
    },
    high: {
      color: colors['risk--high']
    },
    critical: {
      color: colors['risk--critical']
    },
    none: {
      color: colors['risk--benign']
    },
    easy: {
      color: colors['risk--low']
    },
    moderate: {
      color: colors['risk--medium']
    },
    difficult: {
      color: colors['risk--high']
    },
  },

  dropdown: {
    trigger: {
      ':hover': {
        backgroundColor: linkHoverColor
      }
    },
    list: {
      background: palette.gray2,
      boxShadow: '0 16px 40px rgba(0, 0, 0, 0.4)',
      border: '1px solid #777777'
    },
    item: {
      ':hover': {
        backgroundColor: linkHoverColor
      }
    },
    hr: {
      borderColor: 'rgba(255, 255, 255, 0.15)',
    },
    button: {
      default: {
        color: mainTextColor,
      },
      hover: {
        backgroundColor: 'rgba(255, 255, 255, 0.15)',
      }
    }
  },

  link: {
    default: {
      color: colors['active-primary'],
      cursor: 'pointer',
      ':hover': {
        color: colors.actionPrimaryHover,
        textDecoration: 'underline',
      },
    },
    noDecoration: {
      color: colors['active-primary'],
      cursor: 'pointer',
      ':hover': {
        color: colors.actionPrimaryHover,
      },
    },
  },

  loader: {
    ringColor: 'rgba(73, 81, 93)',
    barColor: 'rgba(249, 249, 249)',
  },

  modal: {
    backgroundColor: mainBackgroundColor,
    borderColor: dimTextColor,
    color: mainTextColor,
    ribbonBackground: '#627184',
    headerBackgroundColor: '#222',
  },

  navbar: {
    base: {
      color: colors.text,
      backgroundColor: colors['color-background-primary'],
      borderColor: colors.border,
      // activeColor: colors['action-primary'], // Throwing an error
    },
    link: {
      color: colors.text,
      ':hover': {
        backgroundColor: linkHoverColor
      }
    },
    ribbonBackground: '#627184',
    menuItemUnderline: 'rgba(34, 34, 34, 0.6)',
    profile: {
      backgroundColor: colors['color-background-secondary'],
    },
  },

  pane: {
    primary: {
      backgroundColor: colors['color-background-primary'],
      borderColor: colors.border,
    },
    'primary--bright': {
      backgroundColor: colors['color-background-primary--bright'],
      borderColor: colors['border--emphasis'],
    },
    'primary--dim': {
      backgroundColor: colors['color-background-primary--dim'],
      borderColor: colors['border--deemphasis'],
    },
    secondary: {
      backgroundColor: colors['color-background-secondary'],
      borderColor: colors.border,
    },
    'secondary--bright': {
      backgroundColor: colors['color-background-secondary--bright'],
      borderColor: colors['border--emphasis'],
    },
    'secondary--dim': {
      backgroundColor: colors['color-background-secondary--dim'],
      borderColor: colors['border--deemphasis'],
    },
    body: {
      backgroundColor: colors['color-page-background--solid'],
      borderColor: colors['color-page-background--solid'],
    }
  },

  panel: {
    backgroundColor: colors['color-background-primary'],
  },

  pill: {
    default: {
      backgroundColor: palette.gray8,
      color: palette.gray7,
    },
    danger: {
      backgroundColor: palette.red2,
      color: mainTextColor,
    },
    dim: {
      backgroundColor: palette.gray3,
      color: mainTextColor,
    },
  },

  scrollbar: {
    color: 'rgba(255, 255, 255, 0.2)',
  },

  searchInput: {
    boxShadow: '0 0 2px rgba(255, 255, 255, 0.7)',
    borderColor: '#6C7279',
    color: colors.text,
  },

  textInput: {
    primary: {
      backgroundColor: colors['color-background-primary'],
      borderColor: colors.border,
      color: colors.text,
      ':focus': {
        boxShadow: '0 0 4px rgba(255, 255, 255, 0.75)',
      },
    },

    dim: {
      backgroundColor: colors['color-background-primary--dim'],
      borderColor: colors.border,
      color: colors.text,
    },

    transparent: {
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      color: 'inherit',
    }
  },

  widget: {
    header: {
      backgroundColor: mainBackgroundColor,
      color: mainTextColor,
    },

    content: {
      backgroundColor: mainBackgroundColor,
      color: mainTextColor,
    }
  },

  tooltip: {
    backgroundColor: '#2c3a4e',
    color: mainTextColor,
    borderColor: '#222e3e',
    fieldColor,
  },

  section: {
    padding: '1.5em 0',
    borderColor: borderMain,
    borderStyle: 'solid',
    borderWidth: '2px 0 0',
  },

  text: {
    capitalized: {
      letterSpacing: '2px',
      textTransform: 'uppercase',
    },
  },

  variants: {
    h1: {
      fontSize: 4,
      lineHeight: 1.25,
      fontWeight: 300,
    },

    h2: {
      fontSize: 4,
      lineHeight: 1 + 1 / 3,
      fontWeight: 'bold',
      textTransform: 'none', // TODO h2 is upcased globally, need to make that a choice
    },

    h3: {
      fontSize: 4,
      fontWeight: 'normal',
    },

    p: {
      fontSize: 1,
      fontWeight: 'normal',
    }
  },

  freemium: {
    lock: {
      color: colors['freemium-lock']
    }
  }
}

export default theme
